import httpClient from '@/api/http-client';

const endpoint = 'api/countries';

const countriesService = {
  getList: () => httpClient.get(endpoint),
};

export default countriesService;
